export enum ENUM__page_generation_layout {
  EDITOR = 'EDITOR',

  OUTPUTS = 'OUTPUTS',

  //tabs: images, 3d

  ASSETS = 'ASSETS', //layout to edit assets of current generation

  NODES = 'NODES',

  BUNDLES = 'BUNDLES',
}
